module.exports = __webpack_public_path__ + "4fdc43dd197fbcf3a8b75dcf96e2d097.png";